import { GameData } from "./game-data.js";

// All the technologies used in a ship
export default class ShipConfig {
    constructor(data) {
        for (let i = 0; i < GameData.SHIP_TECHNOLOGIES.length; i++) {
            this[GameData.SHIP_TECHNOLOGIES[i].id] = 0;
        }
        this.role = "normal";

        if (data) { // "copy ctor" .. overwrite with whatever is specified, this way we ensure that we have all properties and can more easily create custom ship-configs
            Object.assign(this, JSON.parse(JSON.stringify(data)));
        }
    }

    getRequiredModuleCount() {
        let module_count = 0;
        for (let i = 0; i < GameData.SHIP_TECHNOLOGIES.length; i++) {
            if (GameData.SHIP_TECHNOLOGIES[i].id !== "body") {
                module_count += this[GameData.SHIP_TECHNOLOGIES[i].id];
            }
        }
        return module_count;
    }

    getAvailableModuleCount() {
        return this.body * 5;
    }

    refreshHullLevel() {
        const module_count = this.getRequiredModuleCount();
        this.body = Math.ceil(module_count / 5);
    }
}
